/**
 * Les bornes de validité d'une formule se saisissent au quart d'heure : les formules historiques
 * portent des valeurs comme `10:30`, `11:30` ou `17:30`, et l'API exige le format `HH:mm`.
 * Une liste fermée évite d'avoir à valider une saisie libre côté front.
 */
const mealPlanHours: string[] = [];

for (let hour = 0; hour <= 23; hour++) {
    const paddedHour = `${hour}`.padStart(2, '0');

    for (const minutes of ['00', '15', '30', '45']) {
        mealPlanHours.push(`${paddedHour}:${minutes}`);
    }
}

export const mealPlanHourOptions = mealPlanHours.map((hour) => ({ value: hour, label: hour }));
